import { render, staticRenderFns } from "./modifyTheFriendshipLink.vue?vue&type=template&id=d87d9a5a&scoped=true&"
import script from "./modifyTheFriendshipLink.vue?vue&type=script&lang=js&"
export * from "./modifyTheFriendshipLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87d9a5a",
  null
  
)

export default component.exports